/**
 * This component provides a fixed header / body / footer layout.
 * The footer sticks to the bottom of the page as opposed to fixed - i.e. if the body is small then the footer will be
 * present at the bottom of the page, if the body is large enough it can push the footer out of the viewport.
 */
import React from 'react';

import styled from 'styled-components';

type PropsHeader = {
    headerHeight?: number;
};

type PropsFooter = {
    footerHeight?: number;
};

type FixedHeaderLayoutProps = PropsHeader &
    PropsFooter & {
        className?: string;
        headerContent: React.ReactNode;
        bodyContent: React.ReactNode;
        footerContent: React.ReactNode;
    };

const Container = styled('div')<PropsHeader>`
    height: 100vh;
    display: grid;
    grid-template-rows: ${(props) => props.headerHeight || '48'}px auto;
`;

const Header = styled('header')<PropsHeader>`
    box-sizing: border-box;
    height: ${(props) => props.headerHeight || '48'}px;
`;

const ScrollableArea = styled('div')<PropsFooter>`
    display: grid;
    grid-template-rows: auto ${(props) => props.footerHeight || '30'}px;
    overflow: auto;
`;

const Footer = styled('footer')<PropsFooter>`
    height: ${(props) => props.footerHeight || '30'}px;
`;

const HeaderBodyFooterLayout: React.FC<FixedHeaderLayoutProps> = ({
    className,
    headerContent,
    bodyContent,
    footerContent,
    headerHeight,
    footerHeight
}) => (
    <Container className={className}>
        <Header headerHeight={headerHeight}>{headerContent}</Header>
        <ScrollableArea className="HeaderBodyFooterLayout-ScrollableArea" footerHeight={footerHeight}>
            <main>{bodyContent}</main>
            <Footer footerHeight={footerHeight}>{footerContent}</Footer>
        </ScrollableArea>
    </Container>
);

export default HeaderBodyFooterLayout;
